import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { BusinessManagementPropositionDispatcher } from "./Variable";

export interface BusinessManagementPropositionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: ServiceProposition[];
}

export class BusinessManagementPropositionStatic extends BaseStore<BusinessManagementPropositionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(BusinessManagementPropositionDispatcher, (actionData) =>
            this.onBusinessManagementPropositionStoreResponse(actionData)
        );
    }

    public getLastResult(): BusinessManagementPropositionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return JSON.parse(JSON.stringify(this.getState().data));
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): BusinessManagementPropositionStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onBusinessManagementPropositionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
